import React from 'react';
import PropTypes from 'prop-types';

export const Column = ({ children, columnWidth }) => (
    <div style={{ width: columnWidth + '%' }}>{children}</div>
);

Column.propTypes = {
    columnWidth: PropTypes.number.isRequired,
    children: PropTypes.array,
};
